import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { SetupSlice, createSetupSlice } from "./setup";

export const useSetupStore = create<SetupSlice>()(
  immer((...a) => ({
    ...createSetupSlice(...a),
  }))
);
